import { Tooltip } from "primereact/tooltip";
import { UNIT_STATUS_ITEMS } from "./constants";
import { UnitStatusSummaryProps } from "./types";

export function UnitStatusSummary(props: UnitStatusSummaryProps) {
  return (
    <div className="flex flex-wrap gap-3">
      {UNIT_STATUS_ITEMS.map((item) => (
        <div
          key={item.key}
          className="flex-1 min-w-12rem sm:min-w-14rem lg:min-w-16rem"
        >
          <div
            className={`p-3 border-round-xl cursor-pointer transition-all hover:shadow-3 ${item.bg}`}
            data-pr-tooltip={item.label}
            data-pr-position="top"
          >
            <div className="flex align-items-center gap-3">
              <div className={`p-2 border-circle ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="flex flex-column">
                <span className="text-md font-medium text-900">
                  {item.label}
                </span>
                <span className="text-sm text-600">
                  {props[item.key as keyof UnitStatusSummaryProps]} units
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
      <Tooltip target="[data-pr-tooltip]" />
    </div>
  );
}
